import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {Provider} from "react-redux";
import {store} from "./redux/store";
import {QueryClient, QueryClientProvider} from "react-query";
import {ToastContainer} from "react-toastify";
import './hooks/i18n';
import UnauthorizedIndex from "./component/unauthorized";
import {ErrorBoundary} from "react-error-boundary";
import AppProvider from "./Provider/AppProvider";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchInterval: false
        }
    }
});
const root = ReactDOM.createRoot(document.getElementById("root")as HTMLElement);
root.render (
    <React.StrictMode>
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>

                <AppProvider>
                    <App/>
                </AppProvider>

                <ToastContainer/>
            </QueryClientProvider>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
